import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import ParticipantSearch from './Search/Filters/ParticipantSearch';
import TextSearch from './Search/Filters/TextSearch';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

import ThreadSearchResults from './Search/ThreadSearchResults';
import TextSearchResults from './Search/TextSearchResults';

const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: 'center',
	color: theme.palette.text.secondary,
  }));

export default function Search() {
	const { searchString } = useParams();

	const [results, setResults] = useState([]);
	const [textResults, setTextResults] = useState([]);
	const [loading, setLoading] = useState(0);
	const [searchType, setSearchType] = useState('participant'); // 'participant' or 'text'

	const threadsFound = React.useCallback((searchData) => {
		console.log(searchData);

		// Check if this is text search results (has 'data' array) or participant search results (has 'threads' object)
		if (searchData.data && Array.isArray(searchData.data)) {
			// Text search results
			setSearchType('text');
			setTextResults(searchData.data);
			setResults([]);
		} else if (searchData.threads) {
			// Participant search results
			setSearchType('participant');
			const rows = Object.keys(searchData.threads).map((t)=> {
				const r = searchData.threads[t];
				return [t, r.map((c) => {
					return [c.number, c.name, c.initials];
				})];
			});
			setResults(rows);
			setTextResults([]);
		} else {
			// Empty or error results
			setResults([]);
			setTextResults([]);
		}
		setLoading(0);
	}, []);

	const threadsLoading = React.useCallback(() => {
		console.log("loading thread data...");
		setLoading(1);
	}, []);

	return (
	<>
	<Stack spacing={2}>
		<Item>
			<Typography variant="h5" component="h2" sx={{ mb: 2 }}>
				Search Records
			</Typography>
			<Typography variant="h6" component="h3" sx={{ mb: 1 }}>
				Text Search
			</Typography>
			<TextSearch
				threadsLoadingCallback={threadsLoading}
				threadsCallback={threadsFound}
			/>
		</Item>
		<Item>
			<Typography variant="h6" component="h3" sx={{ mb: 1 }}>
				Participant Search
			</Typography>
			<ParticipantSearch
				threadsLoadingCallback={threadsLoading}
				threadsCallback={threadsFound}
				initialFilters={searchString}
			/>
		</Item>
	</Stack>
	{searchType === 'text' ? (
		<TextSearchResults
			data={textResults}
			loading={loading}
		/>
	) : (
		<ThreadSearchResults
			rows={results}
			loading={loading}
		/>
	)}
	</>
	)
}

